import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'environments/environment';
import { AccountService } from '../account.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrentUser } from 'app/services/currentUser.service';


@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['../account.scss', './login.component.scss'],
})
export class LoginComponent implements OnInit {
  errors: any = {};
  isLoading;
  redirectUrl;
  socialLogins = environment.socalLogins;

  constructor(
    public activatedRoute: ActivatedRoute,
    public accountService: AccountService,
    public router: Router,
    private currentUser: CurrentUser,
    ) {}

  ngOnInit() {
    if (this.activatedRoute.snapshot.queryParamMap.get('contrib')) {
      this.redirectUrl = this.activatedRoute.snapshot.queryParamMap.get('contrib');
    } else {
      this.redirectUrl = this.activatedRoute.snapshot.queryParamMap.get('next');
    }
  }

  setIsLoading(ev) {
    this.isLoading = ev;
  }

  setError(ev) {
    this.errors = ev;
  }

}
